import React, { Component } from 'react';
import ReactSelect from 'react-select';

import { ArrowDown, Close } from './Icons';

const dropdownIndicatorRenderer = ({ innerProps, isDisabled }) =>
  !isDisabled ? (
    <div {...innerProps}>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 8.5 12"
        xmlSpace="preserve"
        fill="currentColor"
      >
        <path d="M4.5,11.15,8.07,7.57a.25.25,0,0,1,.36.36l-4,4a.27.27,0,0,1-.36,0l-4-4a.27.27,0,0,1,0-.36.27.27,0,0,1,.36,0L4,11.15V.25a.25.25,0,0,1,.5,0Z" />
      </svg>
    </div>
  ) : null;

const clearIndicatorRenderer = ({ innerProps, isDisabled }) =>
  !isDisabled ? <div {...innerProps}>{Close}</div> : null;

class Select extends Component {
  render() {
    return (
      <ReactSelect
        components={{
          DropdownIndicator: dropdownIndicatorRenderer,
          ClearIndicator: clearIndicatorRenderer,
        }}
        className="select"
        classNamePrefix="select"
        {...this.props}
      />
    );
  }
}

export default Select;
